import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Header from "../../components/layouts/Header/OverviewHeader";
import Footer from "../../components/layouts/Footer/OverviewFooter";
import * as styles from "./overviewStyles";
import { Card, CardContent, CardMedia, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useCaptains } from "../../hooks/useCaptains";


const Overview = () => {
    const { data: captains, isLoading } = useCaptains();

    if (isLoading) {
        return (
            <Box sx={styles.homeContainer}>
                <Header />
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "50vh", fontSize: "1.5rem" }}>
                    Loading captains...
                </Box>
                <Footer />
            </Box>
        );
    }

    return (
        <Box sx={styles.homeContainer}>
            <Header />
            <Box>
                <Grid container sx={styles.answersGrid}>
                    {captains.filter(captain => captain.overviewImageUrl).map(captain => (
                        <Grid item key={captain.route} sx={styles.grid}>
                            <Card
                                component={Link}
                                to={captain.route}
                                sx={styles.card}
                            >
                                <CardMedia
                                    image={captain.overviewImageUrl}
                                    sx={styles.cardMedia}
                                />
                                <CardContent sx={styles.cardContent}>
                                    <Typography gutterBottom component="div" sx={styles.typography}>
                                        {captain.firstName} {captain.lastName}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
            <Footer />
        </Box>
    );
};

export default Overview;
